import { Button, Link } from "@chakra-ui/react";

import React from "react";
import jwtDecode from "jwt-decode";
import { useState } from "react";

import useAuth from "../../useAuth";
import { navigate } from "gatsby";
import { HiArrowRight } from "../../customIcons";

const CheckOutButton = ({ title, withIcon, width, isDisabled }: any) => {
  const { loggedIn } = useAuth();
  const [session] = useState(() => {
    try {
      if (typeof window !== "undefined") {
        const jwtSession = window.localStorage.getItem("woo-session");

        const decoded = jwtDecode<{ data: { customer_id: string } }>(
          jwtSession!,
        );

        return decoded.data.customer_id;
      }
    } catch (error: any) {
      return null;
    }
  });

  if (!loggedIn) {
    return (
      <Button
        width={width}
        variant="solid"
        borderRadius="4px"
        background="#3B2060"
        h="40px"
        color="#fff"
        fontSize="16px"
        fontWeight="600"
        _hover={{ background: "#6A3AAB" }}
        rightIcon={withIcon && <HiArrowRight />}
        onClick={() => {
          navigate("/sign-in", {
            state: {
              redirectTo: "/cart",
            },
          });
        }}
        isDisabled={isDisabled}
      >
        Log in to check out
      </Button>
    );
  }

  return (
    <Link
      href={`https://shop.medsupplysolutions.com/checkout/?session_id=${session}`}
      _hover={{ textDecoration: "none" }}
      w="100%"
    >
      <Button
        width={width}
        variant="solid"
        borderRadius="4px"
        background="#3B2060"
        h="40px"
        color="#fff"
        fontSize="16px"
        fontWeight="600"
        _hover={{ background: "#6A3AAB" }}
        rightIcon={withIcon && <HiArrowRight />}
        isDisabled={isDisabled}
      >
        {title}
      </Button>
    </Link>
  );
};

export default CheckOutButton;
